// src/App.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HistoryPage from './pages/HistoryPage';
import TabSwitcher from './components/TabSwitcher';
import Help from './pages/Help';
import Disclaimer from './pages/Disclaimer';
import { useGA4Pageviews } from './analytics/useGA4Pageviews';
import UpdateBanner from './components/UpdateBanner';
function App() {
  useGA4Pageviews();

  return (
    <>
      <Header />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<TabSwitcher />} />
          <Route path="/help" element={<Help />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <UpdateBanner />
    </>
  );
}

export default App;
